import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function useMidnightRedirect(
  isAuthenticated,
  dashboardRoute = "/dashboard"
) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) return; // ⛔ guard

    const now = new Date();
    const nextMidnight = new Date();
    nextMidnight.setHours(24, 0, 0, 0);

    const timeoutMs = nextMidnight.getTime() - now.getTime();

    const timer = setTimeout(() => {
      navigate(dashboardRoute, { replace: true });
      window.location.reload(); // optional
    }, timeoutMs);

    return () => clearTimeout(timer);
  }, [isAuthenticated, navigate, dashboardRoute]);
}
